import fetch from 'services/request';
import { IApiGetCouponReceiveV2Body } from '../types';

const getSubmitReceiveCoupon = (phone: string, name: string, birthday?: string, email?: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/submit-receive-coupon',
    body: { phone, name, birthday, email },
  });
};

const verifyOTP = (refId: string, otpValue: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/verify-otp',
    body: { refId, otpValue },
  });
};

const getCouponListByType = (shopId: string, type: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/coupon/list-by-type/${type}`,
    shopId
  });
};

// /api/v1/customer/referral-discount-exits-customer
const getReferralDiscountExitsCustomer = (shopId: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/referral-discount-exits-customer',
    shopId
  });
};

const sendReferralFriends = (body: { phones: string[], customerId: string }) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/send-referral-friends',
    body
  });
};

const checkByPhone = (phoneNumber: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/customer/check-by-phone/${phoneNumber}`,
  });
};

const getCouponReceiveV2 = (body: IApiGetCouponReceiveV2Body) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/get-coupon',
    body,
  });
};

const couponApis = {
  getSubmitReceiveCoupon,
  verifyOTP,
  getCouponListByType,
  getReferralDiscountExitsCustomer,
  sendReferralFriends,
  checkByPhone,
  getCouponReceiveV2,
};

export default couponApis;
